import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors, FontWeight } from '../../assets/styles';

const useStyles = makeStyles((theme: Theme) => {
  const pxToRem = (px: number): string => `${px / 16}rem`;

  const commonBtn = {
    width: 'auto',
    minWidth: 100,
    height: 32,
  };

  return {
    container: {
      padding: `${pxToRem(40)} ${pxToRem(32)}`,
      width: '100%'
    },
    title: {
      marginBottom: `${pxToRem(32)} !important`,
    },
    content: {
      marginBottom: pxToRem(32),
      color: Colors.Blue,
      fontWeight: FontWeight.Regular,
    },
    actions: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    cancelBtn: {
      ...commonBtn,
      marginRight: 10,
      textTransform: 'none' as const,
    },
    acceptBtn: {
      ...commonBtn,
    },
  };
});

export default useStyles;